<template>
  <li>
    <div
      class="is-flex is-align-items-center is-clickable py-1"
      @click="toggle"
    >
      <span class="icon is-small mr-1">
        <i
          :class="{
            'fa fa-folder has-text-warning': isDirectory && !collapsed,
            'fa fa-folder-open has-text-info': isDirectory && collapsed,
            'fa fa-file': !isDirectory,
          }"
        ></i>
      </span>
      <span>{{ node.name }}</span>
    </div>

    <!-- Render children recursively -->
    <ul v-if="isDirectory && collapsed" class="ml-4">
      <FileNode
        v-for="(child, index) in node.children"
        :key="index"
        :node="child"
        @select_file="onChildFileSelected"
      />
    </ul>
  </li>
</template>

<script>
export default {
  name: "FileNode",
  props: {
    node: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      collapsed: false,
    };
  },
  computed: {
    isDirectory() {
      return this.node.type === "directory";
    },
  },
  methods: {
    toggle() {
      let v = this;
      if (v.isDirectory) {
        v.collapsed = !v.collapsed;
      } else {
        v.$emit("select_file", { ...v.node });
      }
    },
    onChildFileSelected(file) {
      // Propagar el evento hacia arriba cuando un hijo emite select_file
      this.$emit("select_file", file);
    },
  },
};
</script>

<style scoped>
ul {
  list-style: none;
  padding-left: 0;
}
</style>
